export default {
      id: "saving-2-usage",
      viewBox: "0 0 26 32",
      url: __webpack_public_path__ + "sprite.svg#saving-2",
      toString: function () {
        return this.url;
      }
    }